let _ = require('lodash');
let Simple = require('./simple');

class Filter {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, this.$context.props));
    }
}

module.exports = {
    constructor: Filter,
    children: [
        {
            name: 'simple',
            component: Simple,
            parentPropsMap: {
                onFilter: 'onFilter',
                basePath: 'basePath',
                minLength: 'minLength',
                treeId: 'treeId'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/filterable-tree/filter/index.js